import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appPAndESignatures]',
    standalone: false
})
export class PAndESignaturesDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
